import { Observable, EMPTY, of } from 'rxjs'
import { mergeMap, delay } from 'rxjs/operators'
import { ofType, StateObservable } from 'redux-observable'
import { GlobalState } from 'store'
import { NotificationActionTypes, NotificationActions } from 'store/notification'
import { BTQAction } from 'epics'

export type ShowGrowlAction = ReturnType<typeof NotificationActions.showGrowl>

export function growlTimeoutEpic(
  action$: Observable<BTQAction>,
  _state$: StateObservable<GlobalState>,
  _dependencies: {}
): Observable<BTQAction> {
  return action$.pipe(
    ofType<BTQAction, NotificationActionTypes.GROWL_CREATE, ShowGrowlAction>(NotificationActionTypes.GROWL_CREATE),
    mergeMap(action => {
      if (action.payload.timeout) {
        const dismissAction = NotificationActions.dismissGrowl(action.payload.id)
        return of(dismissAction).pipe(delay(action.payload.timeout))
      } else {
        return EMPTY
      }
    })
  )
}
